import React, { FC } from 'react';

import { useI18n } from '../../hooks/useI18n';
import { ClientError } from '../ClientError/ClientError';

import styles from './Error.module.css';

export const Error: FC = () => {
    const i18n = useI18n();

    return (
        <div className={styles.root}>
            <ClientError
                status={404}
                title={i18n('error__title')}
                description={i18n('error__description')}
            />
        </div>
    );
};
